import axios from 'axios'

export default () => {
    const instance = axios.create({
        baseUrl: "/",
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    })

    // Request interceptors for API calls
    instance.interceptors.request.use(
        config => {
            if (config.url.includes("?")) {
                config.url = config.url + "&culture=en"
            } else {
                config.url = config.url + "?culture=en"
            }
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );

    return instance
}
